/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { useQuery } from '@/hooks/query.hook';
import { PageURLs } from '@/utils/navigate';
import { Typography, Button, Tabs } from 'antd';
import type { TabsProps } from 'antd';
import { Icon } from '../../components/icons';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { getListOptions, watchOptionsList } from '@/redux/slices/options.slice';
import { useEffect, useMemo, useState } from 'react';
import { BannerSliderCreateForm } from '@/components/forms/banner-slider-create.form';
import { PermissionMode } from '@/enums/mode.enum';

export const BannerSliderCreate = () => {
  const { push } = useQuery();
  const platformList = useAppSelector(watchOptionsList);
  const dispatch = useAppDispatch();
  const [key, setKey] = useState<string>(platformList[0]?.id.toString());
  const onChange = (key: string) => {
    setKey(key);
    push(`${PageURLs.ofHomeBannerSlider()}?mode=${PermissionMode.CREATE}`);
  };
  const handleGoBack = () => {
    push(PageURLs.ofHomeBannerSlider());
  };
  const itemTabs: TabsProps['items'] = useMemo(
    () =>
      platformList.map((platform) => ({
        key: platform?.id.toString(),
        label: platform.name,
        children: (
          <BannerSliderCreateForm
            id={key || platform?.id.toString()}
            handleGoBack={handleGoBack}
          />
        )
      })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [platformList, key]
  );

  useEffect(() => {
    dispatch(getListOptions({ code: 'PLAT_FORM' }));
  }, [dispatch]);

  return (
    <div css={rootStyles}>
      <div css={boxStyles}>
        <Typography.Title css={titleStyles} level={5}>
          <Button
            css={goBackBtnStyles}
            onClick={handleGoBack}
            type='text'
            icon={<Icon type='arrowLeft' width={20} height={20} />}
          />
          Thêm mới banner
        </Typography.Title>
      </div>
      <div css={boxStyles}>
        <Tabs items={itemTabs} onChange={onChange} />
      </div>
    </div>
  );
};

const rootStyles = css`
  background: var(--gray-soft-color);
  display: flex;
  flex-direction: column;
  gap: 1.4rem;
  padding: 1.4rem 2.4rem;
  min-height: calc(100vh - var(--header-height));
`;

const boxStyles = css`
  padding: 1.4rem 2rem;
  background: var(--white-color);
  border-radius: 1rem;
  box-shadow: 0.02rem 0.04rem 0.2rem var(--gray-light-color);
  &:nth-of-type(2) {
    padding: 1.6rem 3.2rem;
  }
`;

const titleStyles = css`
  display: flex;
  gap: 0.6rem;
  align-items: center;
  position: relative;
  left: 2rem;
  margin-bottom: 0 !important;
`;

const goBackBtnStyles = css`
  position: absolute;
  left: -3rem;
  width: 2.6rem !important;
  height: 2.6rem !important;
  padding: 0;
  svg {
    margin-top: 0.1rem;
  }
  &:hover {
    border-radius: 50%;
  }
`;
